import type { FC, ReactNode } from 'react'

import { ArrowUp, ArrowUpRight, Mail } from 'lucide-react'
import AppLogo from '@/components/generals/app-logo'
import { appLinks, siteConfig } from '@/constants/site'

const LEGAL_LINKS = [
    { label: 'Privacy', href: appLinks.privacy },
    { label: 'Terms', href: appLinks.terms },
    { label: 'Delete account', href: appLinks.deleteAccount }
]

const SiteFooter: FC = (): ReactNode => {
    return (
        <footer id='site-footer' className='border-t border-border bg-background'>
            <div className='mx-auto max-w-7xl px-5 py-12 sm:px-8 lg:py-14'>
                <div className='flex flex-col gap-8 md:flex-row md:items-end md:justify-between'>
                    <div>
                        <AppLogo />

                        <p className='mt-4 text-sm text-muted-foreground'>
                            {siteConfig.tagline}
                        </p>
                    </div>

                    <a
                        href={`mailto:${appLinks.supportEmail}`}
                        className='group inline-flex w-fit items-center gap-2.5 rounded-lg text-sm font-semibold text-foreground transition-colors hover:text-brand'
                    >
                        <Mail className='size-4 text-brand' />
                        {appLinks.supportEmail}
                        <ArrowUpRight className='size-4 transition-transform duration-200 group-hover:-translate-y-0.5 group-hover:translate-x-0.5' />
                    </a>
                </div>

                <div className='mt-10 flex flex-col gap-5 border-t border-border pt-6 text-sm text-muted-foreground md:flex-row md:items-center md:justify-between'>
                    <p>
                        © 2026 {siteConfig.name}
                    </p>

                    <nav aria-label='Legal'>
                        <ul className='flex flex-wrap gap-x-6 gap-y-2'>
                            {LEGAL_LINKS.map((link) => (
                                <li key={link.label}>
                                    <a
                                        href={link.href}
                                        target='_blank'
                                        rel='noopener noreferrer'
                                        className='transition-colors hover:text-foreground'
                                    >
                                        {link.label}

                                        <span className='sr-only'>
                                            (opens in a new tab)
                                        </span>
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </nav>

                    <a
                        href='#top'
                        className='inline-flex w-fit items-center gap-1.5 transition-colors hover:text-foreground'
                    >
                        Back to top
                        <ArrowUp className='size-3.5' />
                    </a>
                </div>
            </div>
        </footer>
    )
}

export default SiteFooter
